<template>
  <div class="d-flex pt-1">
    <v-btn
      x-small
      title="Xem chi tiết"
      icon
      fab
      @click.stop="showFeatureForm"
      v-if="feature"
    >
      <v-icon small>mdi-information-outline</v-icon>
    </v-btn>
    <v-btn
      x-small
      title="Bay tới"
      icon
      fab
      @click.stop="flyTo"
      v-if="feature && feature[field_geometry]"
    >
      <v-icon small>mdi-crosshairs-gps</v-icon>
    </v-btn>
  </div>
</template>
<script>
import Vue from 'vue'

export default Vue.extend({
  computed: {
    field_geometry() {
      return this.params.layer.field_geometry
    },
    feature() {
      return this.params.data
    },
  },
  methods: {
    async showFeatureForm() {
      let feature = this.params.data
      let layer = this.params.layer
      let action = this.params.action
      feature.layer_id = layer.info.id
      action.showDetail(feature)
    },
    async flyTo() {
      let feature = this.params.data
      let layer = this.params.layer
      let action = this.params.action
      let field_geometry = layer.field_geometry
      if (feature[field_geometry]) {
        let geometry = feature[field_geometry]
        action.fitBounds(geometry)
        action.hightlight(feature)
      }
    },
  },
})
</script>
